import React, { Component, Fragment } from 'react';
import ReactTable from 'react-table'
import { showFile, _addNotificationError,  _addNotification } from '../../../../server/util'
import { get, put, putWithHeadersResponse } from '../../../../server/actions'
import NotificationSystem from 'react-notification-system';

import Modal from 'react-modal';
import { add } from 'lodash';

const modalStyles = {
    content: {
        top: '40%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '30%',
        transform: 'translate(-50%, -50%)',
        overflow: 'initial'
    }
};

class AdverseActionReport extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: [],
            originalData: [],
            eligibilityCodes: [],
            showFinalDecisionModal: false,
            selectedRow: null,
            showProgramDropdown: false,
            selectedProgram: '',
            selectedEligibilityCode: '',
            decisionType: ''
        } 
    }

    componentDidMount = () => {
        this.getData();
        this.getEligibilityCodes();
        this._notificationSystem = this.refs.notificationSystem;   
    }
    
    getEligibilityCodes = () => {
            const _self = this;
            get(`/eligibilityCodes/search/findByIsActive?isActive=true&access_token=`).then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
            }).then(data => {
                this.setState({
                    eligibilityCodes: data._embedded.eligibilityCodes, loading: false
                });
    
            }).catch(
                (error) => {
                    this.setState({
                        eligibilityCodes: [], loading: false
                    });
                    console.log('Eligibility Codes errors:', error)
                }
            )
    }

    getData = () => {
       const schoolYear = sessionStorage.getItem('schoolYearValue') || '';
       const schoolId = sessionStorage.getItem('SchoolId') || '';
        this.props.showHideLoading( true);
              get(`/adverseAction/students/${schoolId}/${schoolYear}?studentRecId=&access_token=`).then((response) => {
                  if (!response.ok) {
                      throw Error(response.statusText);
                  }
                  console.log('response', response);
                  return response.json();
                 }).then(data => {
                const respData = Array.isArray(data.resp) ? data.resp : [];
                const tableData = respData.map(item => ({
                    studentId: item.studentId || item.studentRecId || '',
                    studentName: item.studentName || `${item.studentFname || ''} ${item.studentLname || ''}`.trim(),
                    originalStatus: item.originalStatus || item.adverseNewStatus || item.gradeName || '',
                    expirationDate: item.expirationDate || item.expirationDateTime || '',
                    newStatus: item.newStatus || item.currentStatus || '',
                    appealFiled: !!item.appealFiled,
                    finalDecision: !!item.finalDecision,
                    ...item
                }));

                this.setState({ data: tableData, originalData: tableData });
                this.props.showHideLoading(false);
            }).catch((error) => {
                console.error('Error fetching adverse action data:', error);
                this.props.showHideLoading(false);
            });
    };

  filterSchool = (event) => {
    const value = (event.target.value || '').toLowerCase().trim();
    // Restore all data
            if (!value) {
                this.setState({
                    data: this.state.originalData
                });
                return;
            }
        const filteredData = this.state.originalData.filter(item => {
        const studentId = (item.studentId || '').toString().toLowerCase();
        const firstName = (item.studentFName || '').toLowerCase();
        const lastName = (item.studentLName || '').toLowerCase();
        const fullName = `${firstName} ${lastName}`.trim();
        const originalEligStatus = (item.originalEligStatus || '').toLowerCase();
        const newEligStatus = (item.adverseNewStatus || '').toLowerCase();
        const expirationDate = (item.adverseExpirationDate || '').toLowerCase();
              return (
                        studentId.includes(value) ||
                        firstName.includes(value) ||
                        lastName.includes(value) ||
                        fullName.includes(value) ||
                        originalEligStatus.includes(value) ||
                        newEligStatus.includes(value) ||
                        expirationDate.includes(value)
                    );
             });
          this.setState({  data: filteredData });
    };  

    handleChangeAppeal = (row) => {
        this.setState({
            showAppealModal: true,
            selectedRow: row.original
        });
        };
  
    closeAppealModal = () => {
        this.setState({
            showAppealModal: false,
            selectedRow: null
        });
    };

    handleFinalDecision = (row) => {
      this.setState({
        showFinalDecisionModal: true,
        selectedRow: row.original,
        showProgramDropdown: false,
        selectedProgram: ''
     });
    };

    handleDecisionChoice = (type) => {
        if (type === 'YES') {
            this.setState({
            decisionType: 'YES',
            showProgramDropdown: true,
            selectedProgram: '',
            selectedEligibilityCode: ''
            });
        } else {
            this.setState({
            decisionType: 'NO',
            showProgramDropdown: false,
            selectedProgram: '',
            selectedEligibilityCode: ''
            });
        }
    };

   closeFinalDecisionModal = () => {
        this.setState({
            showFinalDecisionModal: false,
            selectedRow: null,
            showProgramDropdown: false,
            decisionType: '',
            selectedProgram: '',
            selectedEligibilityCode: ''
        });
  };

updateFinalDecision = (statusChange) => {
  const { selectedRow, selectedProgram, selectedEligibilityCode } = this.state;

    if (statusChange && !selectedProgram) {
        alert('Please select a program');
        return;
    }

    if (statusChange && selectedProgram !== 'Regular' && !selectedEligibilityCode) {
        alert('Please select an eligibility code');
        return;
    }

    let headers = {
                'Content-Type': 'application/json'
            };
        const reqBody = JSON.stringify({
            studentRecId: selectedRow.displayRecId,
            statusChanged: statusChange,
            selectedStatus: selectedProgram,
            category: selectedEligibilityCode || selectedRow.category || '',
            hasAppealFiled: true
        });

     this.props.showHideLoading(true);
    putWithHeadersResponse(`/adverseAction/finalDecision?access_token=`,reqBody, headers)
    .then(response => {
        if (response.status === 400) {
            return response.json().then(data => {
                _addNotificationError(data.statusMessage || 'An error occurred', this);
                this.props.showHideLoading(false);
            });
        }
        if (!response.ok) {
            throw response.text();
        }
        return response.json();
    })
    .then((data) => {
        if (data && data.statusMessage) {
            _addNotification(data.statusMessage, this);
        }
        this.getData();
        this.closeFinalDecisionModal();
        this.props.showHideLoading(false);
    })
    .catch(err => {
        console.error('Error:', err);
        this.props.showHideLoading(false);
    });
   };

confirmAppeal = () => {
    const { selectedRow, data } = this.state;
    
    // Update local state immediately to prevent rapid clicking
    const updatedData = data.map(item => {
        if (item.studentId === selectedRow.studentId) {
            return { ...item, appealFiled: true };
        }
        return item;
    });
    this.setState({ data: updatedData, showAppealModal: false, selectedRow: null });
    
    this.props.showHideLoading(true);
    let requestBody = {
        hasFiledForAppeal: true
    };
    putWithHeadersResponse(`/adverseAction/appealFiled/${selectedRow.displayRecId}?access_token=`, JSON.stringify(requestBody), {
        'Content-Type': 'application/json'
       })
        .then(response => {
            if (response.status === 400) {
                return response.json().then(data => {
                    _addNotificationError(data.errorMessage || 'An error occurred', this);
                    this.getData();
                    this.props.showHideLoading(false);
                });
            }
            if (!response.ok) {
                throw response.text();
            }
            return response.json();
        })
        .then((data) => {
            if (data && data.statusMessage) {
                _addNotification(data.statusMessage, this);
            }
            this.getData();
            this.props.showHideLoading(false);
        })
        .catch(error => {
            console.error('Error filing appeal:', error);
            this.props.showHideLoading(false);
            // Revert state on error
            this.setState({ data: data });
        });
};

downloadPdfLetter = (row) => {
    const filename = `Notification_Letter_${row.original.studentId || row.original.displayRecId}`;

        get(`/adverseAction/letter/${row.original.displayRecId}?access_token=`, {
            headers: {
                'Content-Type': 'application/pdf',
                'Accept': 'application/pdf'
            }
        })
            .then(response => {
                if (!response.ok) {
                    throw Error('Failed to download PDF');
                }
                return response.blob();
            })
            .then(blob => {
                showFile(blob, filename);
            })
            .catch(error => {
                console.error('PDF download error:', error);
            });
     };

    getColumns = () => {
        let columns = [
            { Header: "Student ID", accessor: "studentId", width: 150, style: { textAlign: 'center' } },
            { Header: "Student Name",
                Cell: row => <span>{`${row.original.studentFName || ''} ${row.original.studentLName || ''}`}</span>,  
                width: 150, style: { textAlign: 'center' } },
            { Header: "Original Status", accessor: "originalEligStatus", width: 150, style: { textAlign: 'center' } },
            { Header: "Expiration Date",
                Cell: row => (
                    <span>
                    {
                        row.original.adverseExpirationDate
                        ? row.original.adverseExpirationDate
                        : row.original.hasFiledForAppeal
                            ? 'N/A'
                            : ''
                    }
                    </span>
                ),
                accessor: "adverseExpirationDate",
                width: 150,
                style: { textAlign: 'center' }
            },
            { Header: "New Status", accessor: "adverseNewStatus", width: 150, style: { textAlign: 'center' } },
            { Header: "Appeal Filed",
                Cell: (row) => (
                    <input
                    type="checkbox"
                    checked={row.original.hasFiledForAppeal || false}
                    onChange={() => this.handleChangeAppeal(row)}
                    />
                ),
                width: 150,
                style: { textAlign: 'center' }
             },
           { Header: "Final Decision",
              Cell: (row) => (
                <input
                type="checkbox"
                disabled={!row.original.hasFiledForAppeal}
                checked={row.original.finalDecision || false}
                onChange={() => this.handleFinalDecision(row)}
                />
            ),
                width: 150,
                style: { textAlign: 'center' }
            },
            { Header: "Notification Letter",
               Cell: (row) => (
                <i
                className="fa fa-file-pdf-o"
                style={{ color: 'red', fontSize: '18px' }}
                onClick={() => this.downloadPdfLetter(row)}
                />
            ),
                width: 150,
                style: { textAlign: 'center' }
            }
        ];
        return columns
    }
 sortedData = (data, sortBy) => {
        const sorted = [...this.state.data];
        sorted.sort((a, b) => {
            const dateA = new Date(a.adverseExpirationDate);
            const dateB = new Date(b.adverseExpirationDate);
            return dateB - dateA;
        });
        return sorted;
    }
 
    render() {
        return (
          <Fragment>
             <NotificationSystem ref="notificationSystem" />
            <div className="row">
                <div className="col-xs-3 pull-left">
                    <input type="text" id="search" className="form-control"
                        style={{
                            float: 'left',
                            margin: '5px 0'
                        }}
                        name="search"
                        placeholder="Search.."
                        onKeyUp={this.filterSchool} 
                        />
                </div>
                <div className="col-md-12">
                    <ReactTable className="-striped -highlight"
                        data={this.sortedData()}
                        columns={this.getColumns()}
                        defaultPageSize={10}
                    />
                </div>
            </div>

        <Modal isOpen={this.state.showAppealModal} onRequestClose={this.closeAppealModal}
               style={modalStyles}>
             <h4 className="modal-title modal-title-color">Confirm Appeal Filing</h4>
              <p style={{ marginTop: '15px' }}>
                This student will continue to receive their original benefits until a final hearing decision is made.
              </p>
              <div className='text-right'>
              <button type="button" className="btn btn-primary btn-sm" onClick={this.closeAppealModal}>Cancel</button>
              <button type="button" className="btn btn-success btn-sm" onClick={this.confirmAppeal}>Confirm</button>
              </div>
        </Modal>

        <Modal isOpen={this.state.showFinalDecisionModal} onRequestClose={this.closeFinalDecisionModal}
                style={modalStyles}>
              <p>Has the student's new status changed?</p>

              <button type="button" className="btn btn-success btn-sm" onClick={() => this.handleDecisionChoice('YES')}>Yes</button>
              <button type="button" className="btn btn-primary btn-sm" onClick={() => this.handleDecisionChoice('NO')}>No</button>

              {this.state.showProgramDropdown && (
                <div style={{ marginTop: '15px' }}>
                <div>
                  <select
                    value={this.state.selectedProgram}
                    onChange={(e) => this.setState({ selectedProgram: e.target.value, selectedEligibilityCode: '' })}
                  >
                    <option value="">Select Program</option>
                    <option value="Free">Free</option>
                    <option value="Reduced">Reduced</option>
                    <option value="Regular">Paid/Regular</option>
                  </select>

                </div>
                {this.state.selectedProgram === 'Free' || this.state.selectedProgram === 'Reduced' ? (
                   <div style={{ marginTop: '10px' }}>
                        <div className="form-group">
                            <label htmlFor="editEligibilityCodes">
                                Eligibility Codes:
                            </label>

                            <select
                                className="form-control"
                                id="editEligibilityCodes"
                                value={this.state.selectedEligibilityCode}
                                onChange={(e) => this.setState({ selectedEligibilityCode: e.target.value })}
                                style={{ width: '80%' }}
                                required
                            >
                            <option value=""></option>

                            {
                                (this.state.eligibilityCodes || [])
                                    .filter(code => {
                                        if (this.state.selectedProgram === 'Reduced') {
                                            return code.redElig === true;

                                        } else if (this.state.selectedProgram === 'Free') {
                                            return code.freeElig === true;
                                        } else {
                                            return false;
                                        }
                                    })
                                    .map((code, i) => (
                                        <option key={i} value={code.codeDesc}>
                                            {code.codeDesc}
                                        </option>
                                    ))
                            }
                            </select>
                        </div>
                    </div>
                   ) : null}
                </div>               
              )}             
              {this.state.decisionType === 'NO' && (
                <button type="button" className="btn btn-success btn-sm" onClick={() => this.updateFinalDecision(false)} >Confirm With Existing Status</button> 
              )}
                <button type="button" className="btn btn-primary btn-sm" onClick={this.closeFinalDecisionModal}>Cancel</button>
              {this.state.decisionType === 'YES' && (
                <button type="button" className="btn btn-success btn-sm" onClick={() => this.updateFinalDecision(true)}>Update</button>
               )}
        </Modal>
        </Fragment>
     );
  }
}

export default AdverseActionReport;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Reports/CliamReport/adverseActionReport.jsx